import { Injectable } from '@angular/core';
import { AuthenticationService } from './authenticationService';
import { DateUtilsService } from './dateUtils';
import { StringUtilsService } from './string.utils.service';

@Injectable({
  providedIn: 'root'
})
export class UserLocaleService {
  //TODO
  //Override this via environment.js
  private defaultLocale = {
    currency: "USD",
    dateFormat: "MM-DD-yyyy",
    locale: "en-US"
  }

  constructor(
    private authService: AuthenticationService,
    private dateUtilsService: DateUtilsService,
    private stringUtils: StringUtilsService
  ) {
  }

  getLocaleFormattedDate(date, inputDateFormat = 'YYYY-MM-DD') {
    if (!date || Array.isArray(date)) { return '' };
    const userLocale = this.getUserLocale();
    const dtMoment = this.dateUtilsService.getDateInMomentWithFormat(date, inputDateFormat);
    return dtMoment.format(userLocale.dateFormat);
  }

  getLocaleFormattedAmount(amt, options = {}) {
    if (typeof amt === 'undefined' || Array.isArray(amt)) { return '' };
    const userLocale = this.getUserLocale();
    return this.stringUtils.formatNumberAsCurrencyWithLocale(amt, userLocale.locale, userLocale.currency);
  }

  private getUserLocale() {
    const userLocale = (this.authService.currentUserValue || {}).localeUIConfig || this.defaultLocale;
    return userLocale;
  }


}
